import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PERMISSIONS } from "./permissionsList";
import { API_BASE_URL } from "../config";
import "./AdminShared.css";

export default function EditAdmin() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    email: "",
    permissions: [],
  });
  const [msg, setMsg] = useState(null);
  const [loading, setLoading] = useState(true);

  const stored = JSON.parse(localStorage.getItem("adminInfo") || "null");
  const token = stored?.token;

  const fetchAdminDetails = useCallback(async () => {
    try {
        setLoading(true);
        const res = await fetch(`${API_BASE_URL}/admin/by-id/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        setForm({
          name: data.name,
          email: data.email,
          permissions: Array.isArray(data.permissions)
            ? data.permissions
            : data.permissions?.split(",") || [],
        });
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  }, [id, token]);

  useEffect(() => {
    if (!token) return navigate("/admin");
    fetchAdminDetails();
  }, [fetchAdminDetails, token, navigate]);

  const toggle = (key) => {
    setForm((prev) => {
      const has = prev.permissions.includes(key);
      return {
        ...prev,
        permissions: has
          ? prev.permissions.filter((p) => p !== key)
          : [...prev.permissions, key],
      };
    });
  };

  const updateAdmin = async (e) => {
    e.preventDefault();
    setMsg(null);
    try {
        const res = await fetch(`${API_BASE_URL}/admin/${id}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(form),
        });
        const data = await res.json();
        if (!res.ok) return setMsg({ error: data.message });
        setMsg({ success: "✅ Fragment update synchronized successfully." });
        setTimeout(() => navigate("/admin/view-admins"), 1500);
    } catch (err) { setMsg({ error: "Sync failed" }); }
  };

  if (loading) return <div className="admin-list-container"><p style={{padding: '100px', textAlign: 'center'}}>⏳ Synchronizing Operator Identity...</p></div>;

  return (
    <div className="admin-list-container">
      <header className="admin-list-header">
        <div className="header-left-group">
          <button className="admin-back-btn" onClick={() => navigate("/admin/panel")}>←</button>
          <img src="/logo.png" alt="FlyTutor" className="admin-header-logo" />
          <h1 className="admin-header-title">Identity Synchronization</h1>
        </div>
        <div className="module-badge" style={{ background: '#475569' }}>Security</div>
      </header>

      <div className="admin-list-content">
        <div className="admin-info-bar">
          <div className="admin-user-tag">
            <div className="dot" style={{ background: '#475569' }}></div>
            Registry Status: Modifying Operator Profile
          </div>
        </div>

        <div className="admin-table-wrapper" style={{ padding: '40px', background: '#fff' }}>
           <form onSubmit={updateAdmin}>
                <div className="admin-form-elite" style={{ marginBottom: '40px' }}>
                    <label>
                        Operator Identity
                        <input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required />
                    </label>

                    <label>
                        Secure Communication Axis
                        <input type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required />
                    </label>
                </div>

                <div style={{ padding: '30px', background: '#f8fafc', borderRadius: '20px', border: '1px solid #e2e8f0' }}>
                    <h3 style={{ margin: '0 0 20px 0', fontSize: '1.1rem', fontWeight: 800, color: '#0f172a' }}>Permission Access Matrix</h3>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: '15px' }}>
                        {PERMISSIONS.map(p => (
                            <label key={p.key} style={{ 
                                display: "flex", gap: '12px', alignItems: "center", padding: '12px', 
                                background: form.permissions.includes(p.key) ? '#fff' : 'transparent',
                                border: form.permissions.includes(p.key) ? '2px solid #6366f1' : '1px solid #e2e8f0',
                                borderRadius: '12px', cursor: 'pointer', transition: 'all 0.2s ease',
                                margin: 0
                            }}>
                                <input 
                                    type="checkbox" 
                                    className="status-tag" 
                                    style={{ width: '18px', height: '18px', margin: 0 }}
                                    checked={form.permissions.includes(p.key)} 
                                    onChange={() => toggle(p.key)} 
                                />
                                <span style={{ fontSize: '0.85rem', fontWeight: 600, color: form.permissions.includes(p.key) ? '#1e293b' : '#64748b' }}>
                                    {p.label}
                                </span>
                            </label>
                        ))}
                    </div>
                </div>

                <div className="admin-submit-area" style={{ display: 'flex', gap: '15px' }}>
                    <button type="button" className="btn-update" style={{ padding: '16px 30px', background: '#f1f5f9', border: 'none' }} onClick={() => navigate("/admin/panel")}>
                        Abort Changes
                    </button>
                    <button type="submit" className="btn-primary-elite" style={{ background: '#475569' }}>
                        Confirm Sync
                    </button>
                </div>

                {msg?.error && <div style={{ marginTop: '20px', padding: '15px', background: '#fef2f2', color: '#b91c1c', borderRadius: '12px', fontWeight: 700, textAlign: 'center' }}>{msg.error}</div>}
                {msg?.success && <div style={{ marginTop: '20px', padding: '15px', background: '#f0fdf4', color: '#166534', borderRadius: '12px', fontWeight: 700, textAlign: 'center' }}>{msg.success}</div>}
           </form>
        </div>
      </div>
    </div>
  );
}
